import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

/**
 * Dedicated layout for public policy pages (Terms and Policy, Privacy Policy).
 */
const PolicyPageLayout = ({ children, footer = true }) => {
    const outerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '32px 24px',
        background: 'linear-gradient(160deg, var(--dark-bg-start) 0%, rgba(254, 2, 125, 0.35) 50%, var(--dark-bg-start) 100%)',
        backgroundAttachment: 'fixed',
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
    };

    const cardStyle = {
        width: '100%',
        maxWidth: '100%',
        background: 'rgba(255, 255, 255, 0.92)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        border: '1px solid rgba(254, 2, 125, 0.15)',
        borderRadius: 24,
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(255, 255, 255, 0.5) inset, 0 8px 32px rgba(254, 2, 125, 0.08)',
        padding: 0,
        overflow: 'hidden',
        position: 'relative',
    };

    const topAccentStyle = {
        height: 4,
        background: 'var(--gradient-primary)',
        width: '100%',
        flexShrink: 0,
    };

    const innerStyle = {
        padding: '28px 32px 32px',
    };

    const footerStyle = {
        marginTop: 28,
        textAlign: 'center',
        fontSize: '0.75rem',
        color: 'var(--text-gray-dark)',
        opacity: 0.9,
        letterSpacing: '0.02em',
    };

    const bubbles = [
        { size: 120, left: '8%', top: '12%' },
        { size: 80, left: '85%', top: '18%' },
        { size: 160, left: '72%', top: '55%' },
        { size: 60, left: '15%', top: '70%' },
        { size: 100, left: '50%', top: '25%' },
        { size: 90, left: '25%', top: '45%' },
        { size: 70, left: '88%', top: '78%' },
        { size: 130, left: '5%', top: '35%' },
        { size: 55, left: '65%', top: '15%' },
        { size: 85, left: '40%', top: '75%' },
        { size: 95, left: '92%', top: '42%' },
        { size: 75, left: '55%', top: '60%' },
    ];

    return (
        <div className="policy-page-container" style={outerStyle} role="main">
            <div className="auth-bubbles" aria-hidden="true">
                {bubbles.map((b, i) => (
                    <div
                        key={i}
                        className="auth-bubble"
                        style={{
                            width: b.size,
                            height: b.size,
                            left: b.left,
                            top: b.top,
                            animationDelay: `${(i % 5) * 1.2}s`,
                        }}
                    />
                ))}
            </div>
            <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch', width: '100%' }}>
            <div style={cardStyle}>
                <div style={topAccentStyle} />
                <div style={innerStyle}>
                    {children}
                </div>
            </div>
            {footer && (
                <Text style={footerStyle}>
                    © {new Date().getFullYear()} Tandemly. All rights reserved.
                </Text>
            )}
            </div>
        </div>
    );
};

export default PolicyPageLayout;
